import * as React from 'react';
import { ModalProps } from 'react-bootstrap';
import { Style, StyleText } from '../../models';
import { ReportDataService, NotificationService, StyleDataService } from '../../services';
import './Modal.css';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import { FilterStore } from '../../stores';
import { PVAStyleContent } from './PVAStyleContent';

interface ModalContentProps extends ModalProps {
    style: Style;
    name: string;
    notificationService: NotificationService;
    styleDataService: StyleDataService;
    FilterStore?: FilterStore;
}

interface ModalState {
    generating: boolean;
    allStyles?: Style[];
}

@inject('FilterStore') @observer
export class PVAStyleModal extends React.Component<ModalContentProps, ModalState> {
    private reportDataService = new ReportDataService(this.props.notificationService);

    constructor(props: ModalContentProps) {
        super(props);

        this.state = {
            generating: false,
            allStyles: []
        };
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    componentDidMount() {
        this.update();
    }

    componentWillReact() {
        this.update();
    }

    public update() {
        if (this.state.allStyles!.length < 1) {
            this.props.styleDataService.getAllBySurveyVersion(this.surveyVersion!).then((styles: Style[]) => {
                this.setState(() => { return { allStyles: styles }; } );
            });
        }
    }

    public export = () => {
        this.setState(
            {
                generating: true
            },
            () => {
                let id: number = this.getCurrentStyle().id;
                this.reportDataService.getStylePDF(id, this.props.style.name).then(() => {
                    this.setState({
                                      generating: false
                                  });
                }).catch(() => {
                    this.setState({
                                      generating: false
                                  });
                });
            });
    }

    getCurrentStyle() {
        let relevantStyle = this.props.style;
        if (this.state.allStyles!.length > 0) {
            relevantStyle = this.state.allStyles!.filter((style: Style) => {
                return style.name === this.props.style.name;
            })[0];
        }
        return relevantStyle;
    }

    render(): any {
        let relevantStyle = this.getCurrentStyle();
        const sortedAdditionalStyles = relevantStyle.styleTexts.filter((styleText: StyleText) => {
            return styleText.styleTextType === 'additional';
        }).sort((one: StyleText, two: StyleText) => {
            if (one.sort > two.sort) {
                return 1;
            } else if (one.sort < two.sort) {
                return -1;
            }
            return 0;
        });

        if (!this.props.show) {
            return <div />;
        }
        return (
            <PVAStyleContent title={this.props.title!} asModal={true} onHide={this.props.onHide} notificationService={this.props.notificationService} style={relevantStyle} name={this.props.name} exporting={this.state.generating} onExport={this.export} sortedAdditionalStyles={sortedAdditionalStyles} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/inclinationmodals/PVAStyleModal.tsx